import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { deleteIdea } from './api.js';
import { auth } from '../../firebase'; // <-- import Firebase auth
import NewChatButton from './NewChatButton';
import './ChatPage.css';

const Sidebar = ({ projects, onProjectSelect, setProjects, setSelectedProject, setMessages, credit, user_idx }) => {
  const [deleteMode, setDeleteMode] = useState(false);
  const navigate = useNavigate();

  const handleStartDeleteMode = () => {
    setDeleteMode(true);
  };

  const handleCancelDeleteMode = () => {
    setDeleteMode(false);
  };

  const handleDeleteProject = (projectId) => {
    const status = deleteIdea(projectId);
    const updated = projects.filter((p) => p.idx !== projectId);
    setProjects(updated);
    setSelectedProject((prev) => (prev?.idx === projectId ? null : prev));
    setMessages([]);
    setDeleteMode(false);
  };

  const handleLogout = async () => {
    try {
      await auth.signOut();

      // Clear all cached data (e.g., localStorage, sessionStorage)
      localStorage.clear();
      sessionStorage.clear();

      // Optional: If you're using any custom context or Redux state, reset them here

      navigate('/'); // Redirect to home/login page
    } catch (error) {
      console.error('Logout failed:', error);
      alert('Çıkış yapılamadı. Lütfen tekrar deneyin.');
    }
};

  return (
    <div className="sidebar">
      <h2>Aktif Proje Fikirleri</h2>

      <ul className="chat-list">
        {projects.map((proj) => (
          <li
            key={proj.idx}
            className={deleteMode ? 'project-item delete-mode' : 'project-item'}
            onClick={() => {
              if (deleteMode) {
                const confirmDelete = window.confirm(`"${proj.title}" adlı projeyi silmek istediğine emin misin?`);
                if (confirmDelete) {
                  handleDeleteProject(proj.idx);
                } else {
                  setDeleteMode(false);
                }
              } else {
                onProjectSelect(proj);
              }
            }}
          >
            {proj.title}
          </li>
        ))}
      </ul>

      
      <button className="credit-btn" onClick={() => navigate('/credit_checker', { state: { user_idx } })}>
        Kredilerim
      </button>

      <NewChatButton
        setSelectedProject={setSelectedProject}
        setMessages={setMessages}
        credit={credit}
        user_idx={user_idx}
      />

      {!deleteMode ? (
        <button className="delete-btn" onClick={handleStartDeleteMode}>
          Proje Sil
        </button>
      ) : (
        <>
          <button className="cancel-btn" onClick={handleCancelDeleteMode}>
            Silme Modunu İptal Et
          </button>
          <div className="delete-mode-info">
            Silmek istediğiniz projeyi seçiniz.
          </div>
        </>
      )}

      <button className="signout-btn" onClick={handleLogout}>
        Çıkış Yap
      </button>
    </div>
  );
};

export default Sidebar;
